export const SurveyActionTypes = {
    API_RESPONSE_SUCCESS: '@@survey/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@survey/API_RESPONSE_ERROR',

    LIST_SURVEY: '@@survey/LIST_SURVEY',
    SHOW_SURVEY: '@@survey/SHOW_SURVEY',
    FILTER_SURVEY: '@@survey/FILTER_SURVEY',
};